import { defineSprite, sprite, type SpriteDef } from './types';

// UI sprites (docs/07). 1-px ink outline, light from top-left.
export const UI_SPRITES: SpriteDef[] = [
  // Lever: red glossy knob with brass collar, shaded shaft, bolted pivot housing.
  // The Maw's-eye knob (docs/06 §7, BECOME THE MAW): a fleshy ball with a wet eye that looks back.
  sprite('lever_knob_maw', { o: 'ink', p: 'dustyPink', f: 'flesh', c: 'crimson', m: 'maroon', w: 'white', y: 'gold', k: 'ink', s: 'salmonPink', b: 'brass', B: 'bronze', C: 'copper' }, [
    '.......oo.......',
    '....ooosfooo....',
    '...osssffffo....',
    '..osffwwwwffco..',
    '..osfwyyyywfco..',
    '.osffwykkywfcco.',
    '.offfwykkywfccmo',
    '.offfwyyyywccmmo',
    '.offffwwwwccmmmo',
    '..offfcccccmmmo.',
    '..occcccmmmmmmo.',
    '...ommmmmmmmmo..',
    '....oooooooo....',
    '....oCbbbbBo....',
    '....oBBBBBCo....',
    '.....oooooo.....',
  ]),
  sprite('lever_knob', { o: 'ink', w: 'white', h: 'coral', r: 'red', d: 'blood', D: 'maroon', b: 'brass', B: 'bronze', C: 'copper' }, [
    '.......oo.......',
    '....ooohrooo....',
    '...ohhhhrrrro...',
    '..ohwwhrrrrrdo..',
    '..ohwhhrrrrrdo..',
    '.ohhhrrrrrrddDo.',
    '.orrrrrrrrrdDDo.',
    '.orrrrrrrrdDDDo.',
    '.orrrrrrddDDDDo.',
    '..orrrrddDDDDo..',
    '..oddddDDDDDDo..',
    '...oDDDDDDDDo...',
    '....oooooooo....',
    '....oCbbbbBo....',
    '....oBBBBBCo....',
    '.....oooooo.....',
  ]),
  sprite('lever_shaft', { o: 'ink', l: 'lemon', b: 'brass', B: 'bronze', C: 'copper' }, [
    'oooooo',
    'olbbCo',
    'olbbBo',
    'olbbBo',
    'olbbBo',
    'olbbBo',
    'olbbBo',
    'olbbBo',
    'olbbBo',
    'olbbBo',
    'olbbBo',
    'olbbBo',
    'obBBCo',
    'obBBCo',
    'olbbBo',
    'olbbBo',
    'olbbBo',
    'olbbBo',
    'olbbBo',
    'olbbBo',
    'olbbBo',
    'olbbBo',
    'olbbBo',
    'olbbBo',
    'obBBCo',
    'obBBCo',
    'olbbBo',
    'olbbBo',
    'olbbBo',
    'olbbBo',
    'olbbBo',
    'olbbBo',
    'olbbBo',
    'olbbBo',
    'olbbBo',
    'olbbBo',
    'obBBCo',
    'obBBCo',
    'olbbBo',
    'olbbBo',
    'olbbBo',
    'olbbBo',
    'olbbBo',
    'olbbBo',
    'olbbBo',
    'olbbBo',
    'olbbCo',
    'oooooo',
  ]),
  sprite('lever_base', { o: 'ink', l: 'lemon', b: 'brass', B: 'bronze', C: 'copper', k: 'brick', n: 'night', s: 'steel', S: 'lilacGrey' }, [
    '.........oo.........',
    '......ooolbooo......',
    '....oollllbbbboo....',
    '...ollllllbbbbBBo...',
    '..olsSlllbbbbbBsSo..',
    '..olSnlllbbbbbBSno..',
    '.ollllllnnnnbBBCCko.',
    '.olllllnoooonBBCkko.',
    '.olllbnoooooonCCkko.',
    'obbbbbnoolboonCkkkko',
    'obbbbbnoobCoonCkkkko',
    '.obbbbnoooooonkkkko.',
    '.obbbbBnoooonkkkkko.',
    '.oBBBBBBnnnnkkkkkko.',
    '..oBBBCCCCkkkkkkko..',
    '..oCsSCCkkkkkkksSo..',
    '...oSnkkkkkkkkkSn...',
    '....ookkkkkkkkoo....',
    '......oookkooo......',
    '.........oo.........',
  ]),
  // Spinning coin: face → 3/4 → edge → 3/4 (back).
  defineSprite({
    id: 'coin',
    colors: { o: 'ink', l: 'lemon', g: 'gold', a: 'amber', C: 'copper' },
    frames: [
      [
        '..oooo..',
        '.ollggo.',
        'olggggao',
        'olgaagao',
        'oggaagao',
        'oggggaao',
        '.oaaaao.',
        '..oooo..',
      ],
      [
        '..oooo..',
        '.olggCo.',
        '.olgaCo.',
        '.ogaaCo.',
        '.ogaaCo.',
        '.oggaCo.',
        '.oaaaCo.',
        '..oooo..',
      ],
      [
        '...oo...',
        '..olCo..',
        '..olCo..',
        '..ogCo..',
        '..ogCo..',
        '..oaCo..',
        '..oaCo..',
        '...oo...',
      ],
      [
        '..oooo..',
        '.oCggao.',
        '.oCgaao.',
        '.oCgaao.',
        '.oCgaao.',
        '.oCggao.',
        '.oCaaao.',
        '..oooo..',
      ],
    ],
  }),
  // Soul flame flicker loop.
  defineSprite({
    id: 'soul_flame',
    colors: { v: 'violet', l: 'lavender', p: 'pinkLilac', w: 'white' },
    frames: [
      [
        '............',
        '............',
        '......v.....',
        '.....vvv....',
        '.....vlv....',
        '....vvllv...',
        '...vvlllv...',
        '...vllplv...',
        '..vllpplv...',
        '..vlpppllv..',
        '.vvlppwplv..',
        '.vllpwwpllv.',
        '..vlpwwplv..',
        '..vlpppplv..',
        '...vllllv...',
        '.....vv.....',
      ],
      [
        '............',
        '............',
        '............',
        '.....vv.....',
        '....vvv.....',
        '...vvll.....',
        '...vlllv....',
        '...vlllvv...',
        '..vllpplv...',
        '..vlpppllv..',
        '..vlpwpplv..',
        '..llpwwpllv.',
        '..vlpwwplv..',
        '..vlpppplv..',
        '...vllllv...',
        '.....vv.....',
      ],
      [
        '............',
        '............',
        '.....v......',
        '....vvv.....',
        '....vlv.....',
        '...vllvv....',
        '...vlllvv...',
        '...vlpllv...',
        '...vlppllv..',
        '..vllppplv..',
        '..vlpwpplvv.',
        '.vllpwwpllv.',
        '..vlpwwplv..',
        '..vlpppplv..',
        '...vllllv...',
        '.....vv.....',
      ],
      [
        '............',
        '............',
        '............',
        '.....vv.....',
        '.....vvv....',
        '.....llvv...',
        '....vlllv...',
        '...vvlllv...',
        '...vlppllv..',
        '..vllppplv..',
        '..vlppwplv..',
        '.vllpwwpll..',
        '..vlpwwplv..',
        '..vlpppplv..',
        '...vllllv...',
        '.....vv.....',
      ],
    ],
  }),
  // Memory Web nodes.
  sprite('node_stat', { o: 'ink', w: 'white', p: 'paper', s: 'steel', g: 'lilacGrey', d: 'dusk' }, [
    '................',
    '....oooooooo....',
    '...owwwwpppso...',
    '..owwwwppppsso..',
    '.owwwwwpppsssgo.',
    '.owwwwppppssgdo.',
    '.owwpppppsssgdo.',
    '.oppppppsssgddo.',
    '.opppppsssggddo.',
    '.opppssssggdddo.',
    '.ossssssggddddo.',
    '.ossssggddddddo.',
    '..ogggdddddddo..',
    '...oddddddddo...',
    '....oooooooo....',
    '................',
  ]),
  sprite('node_gate', { o: 'ink', l: 'lemon', b: 'brass', B: 'bronze', C: 'copper', k: 'brick', e: 'aubergine', P: 'paper', S: 'steel', W: 'white', a: 'amber', g: 'gold' }, [
    '..........oooo..........',
    '.......ooollbbooo.......',
    '.....oolllllbbbbboo.....',
    '....olllllllbbbbbBBo....',
    '...ollllloooooobbBBCo...',
    '..ollllooeeeeeeooBBlko..',
    '..ollloeeeeeeeeeeoBCko..',
    '.ollloeeeeeeeeeeeeoCkko.',
    '.ollloeeeeooooeeeeoCkko.',
    '.olloeeoooaooaoooeeokko.',
    'obbloeoPPWaooaaPPoeokkko',
    'obbbooPPPagoogaPPPookkko',
    'oblbooPPPagoogaPPPooklko',
    'obbboeoSSaaooaaSSoeokkko',
    '.obboeeoooaooaoooeeokko.',
    '.obbboeeeeooooeeeeokkko.',
    '.oBBBoeeeeeeeeeeeeokkko.',
    '..oBBBoeeeeeeeeeeokkko..',
    '..oClCCooeeeeeeookklko..',
    '...okkkkkooooookkkkko...',
    '....okkkkkkkkkkkkkko....',
    '.....ookkkkklkkkkoo.....',
    '.......oookkkkooo.......',
    '..........oooo..........',
  ]),
  // Small glyphs.
  sprite('hold_icon', { o: 'ink', s: 'steel', l: 'lemon', b: 'brass', B: 'bronze' }, [
    '....oooo....',
    '...os..so...',
    '...os..so...',
    '..oooooooo..',
    '..olbbbbBo..',
    '..obboobBo..',
    '..oBBoBBBo..',
    '..oooooooo..',
  ]),
  sprite('arrow_up', { o: 'ink', w: 'white', p: 'paper', s: 'steel' }, [
    '...oo...',
    '..owpo..',
    '.owppso.',
    'owpppsso',
    'osssssso',
    'oooooooo',
  ]),
  sprite('arrow_down', { o: 'ink', w: 'white', p: 'paper', s: 'steel' }, [
    'oooooooo',
    'owwwppso',
    'owpppsso',
    '.owppso.',
    '..opso..',
    '...oo...',
  ]),
  defineSprite({
    id: 'sparkle',
    colors: { c: 'clover', m: 'mint', i: 'ice', w: 'white' },
    frames: [
      [
        '.....',
        '..c..',
        '.cmc.',
        '..c..',
        '.....',
      ],
      [
        '..m..',
        '..i..',
        'miwim',
        '..i..',
        '..m..',
      ],
      [
        'c...c',
        '.m.m.',
        '..w..',
        '.m.m.',
        'c...c',
      ],
    ],
  }),
  defineSprite({
    id: 'pixel_eye',
    colors: { o: 'ink', p: 'paper', S: 'steel', i: 'lilacGrey', k: 'ink', v: 'salmonPink' },
    frames: [
      [
        '.........',
        '..ooooo..',
        '.oppipSo.',
        'ovpikipSo',
        '.oSpiSSo.',
        '..ooooo..',
        '.........',
      ],
      [
        '.........',
        '.........',
        '.........',
        '.iiiiiii.',
        'i.i.i.i.i',
        '.........',
        '.........',
      ],
    ],
  }),
];
